import React from 'react';
import { ArrowUp, ArrowDown, AlertCircle } from 'lucide-react';

const FinanceiroCard = ({ 
  titulo, 
  valor, 
  subtitulo, 
  variacao, 
  cor = 'blue',
  icone: Icon,
  status = 'normal',
  onClick,
  clicavel = false
}) => {
  // Mapeamento de cores para seguir o padrão Tailwind
  const cores = {
    blue: {
      bg: 'bg-[color:var(--surface)]',
      border: 'border-[color:var(--border)]',
      text: 'text-blue-600',
      icon: 'text-blue-500'
    },
    green: {
      bg: 'bg-[color:var(--surface)]',
      border: 'border-[color:var(--border)]',
      text: 'text-green-600',
      icon: 'text-green-500'
    },
    emerald: {
      bg: 'bg-[color:var(--surface)]',
      border: 'border-[color:var(--border)]',
      text: 'text-emerald-600',
      icon: 'text-emerald-500'
    },
    red: {
      bg: 'bg-[color:var(--surface)]',
      border: 'border-[color:var(--border)]',
      text: 'text-red-600',
      icon: 'text-red-500'
    },
    amber: {
      bg: 'bg-[color:var(--surface)]',
      border: 'border-[color:var(--border)]',
      text: 'text-amber-600',
      icon: 'text-amber-500'
    }
  };

  const statusCores = {
    normal: 'text-[color:var(--text-muted)] bg-[color:var(--surface-muted)]',
    positivo: 'text-[color:var(--status-good)] bg-[color:var(--surface-muted)]',
    negativo: 'text-[color:var(--status-bad)] bg-[color:var(--surface-muted)]',
    alerta: 'text-[color:var(--status-warn)] bg-[color:var(--surface-muted)]'
  };

  const statusIcones = {
    normal: null,
    positivo: <ArrowUp className="h-3 w-3 mr-1" />,
    negativo: <ArrowDown className="h-3 w-3 mr-1" />,
    alerta: <AlertCircle className="h-3 w-3 mr-1" />
  };

  const renderVariacao = () => {
    if (!variacao) return null;

    return (
      <div className={`flex items-center text-xs font-medium px-2 py-1 rounded ${statusCores[status]} mt-2`}>
        {statusIcones[status]}
        <span>{variacao}</span>
      </div>
    );
  };

  const isInteractive = Boolean(clicavel && typeof onClick === 'function');
  const cardClasses = `p-4 sm:p-5 rounded-lg border ${cores[cor].border} ${cores[cor].bg} transition-shadow duration-200 theme-shadow hover:shadow-[0_6px_14px_rgba(0,0,0,0.12)]`;

  const cardContent = (
    <>
      <div className="flex items-center justify-between mb-3">
        <div className="min-w-0 flex-1">
          <p className="text-xs text-[color:var(--text-muted)] font-medium uppercase tracking-wide truncate">{titulo}</p>
          <p className={`text-lg sm:text-xl font-bold mt-1 ${cores[cor].text} break-words`}>{valor}</p>
        </div>
        {Icon && (
          <Icon className={`h-5 w-5 ${cores[cor].icon} flex-shrink-0 ml-2`} />
        )}
      </div>
      
      {subtitulo && (
        <p className="text-xs text-[color:var(--text-muted)] mb-2 truncate">{subtitulo}</p>
      )}
      
      {renderVariacao()}
    </>
  );

  if (isInteractive) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`${cardClasses} w-full text-left cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500/30`}
      >
        {cardContent}
      </button>
    );
  }

  return (
    <div className={cardClasses}>
      {cardContent}
    </div>
  );
};

export default FinanceiroCard;
